import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
// Taking a new version of the app (#317). The service worker no longer takes over by itself (quasar.conf.js:
// skipWaiting off), so a running page keeps the version it started with and its lazy chunks. At the start, before the
// app shows, a new version that is ready, or downloads within BUDGET, is taken with a reload no one sees; while the app
// runs a note offers it for a few seconds (never a reload by itself: that would lose what the user was typing), and the
// next start takes it anyway. Pages from before #317: the bridge in src/statics/js/sw-update-mode.js.
import Notify from 'quasar/src/plugins/Notify.js';;
import { i18nInstance } from 'boot/i18n';
var ON = process.env.PROD && process.env.MODE === 'pwa' && 'serviceWorker' in navigator; // how long a start may wait for the check; then the app starts as it is

var BUDGET = 1500; // back in the app after this long: look for a new version again

var RECHECK = 30 * 60 * 1000; // made once by this code: tells the service worker that the page takes a new version itself (sw-update-mode.js)

var MODE_CACHE = 'xena-update-mode'; // a reload for a new version in the last seconds: don't take another one at this start (no loop)

var RELOADED = 'pwa-update-reloaded'; // the note goes by itself after this long, so it never keeps a control covered (the next start takes the version anyway)

var NOTE_TIME = 12000;
var starting = true;
var taking = false;
var noted = false;

var wait = function wait(ms, value) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(value);
    }, ms);
  });
}; // true once the worker is installed (or further), false when it fails


var installed = function installed(worker) {
  return new Promise(function (resolve) {
    var settle = function settle() {
      if (worker.state === 'redundant') resolve(false);else if (worker.state !== 'installing') resolve(true);
    };

    worker.addEventListener('statechange', settle);
    settle();
  });
};

var justReloaded = function justReloaded() {
  try {
    return Date.now() - Number(sessionStorage.getItem(RELOADED) || 0) < 10000;
  } catch (e) {
    return false;
  }
}; // the waiting version takes over; the page reloads into it (onNewController). false when it doesn't happen within 3 s


var take = function take(reg) {
  if (taking || !reg.waiting) return Promise.resolve(false);
  taking = true;

  try {
    sessionStorage.setItem(RELOADED, String(Date.now()));
  } catch (e) {}

  reg.waiting.postMessage({
    type: 'SKIP_WAITING'
  });
  return wait(3000, false).then(function () {
    taking = false;
    return false;
  });
};

var showNote = function showNote(reload, timeout, onDismiss) {
  return Notify.create({
    message: i18nInstance.t('messages.update_ready'),
    timeout: timeout,
    onDismiss: onDismiss,
    actions: [{
      label: i18nInstance.t('messages.update_reload'),
      color: 'white',
      noCaps: true,
      handler: reload
    }, {
      icon: 'close',
      color: 'white',
      round: true
    }]
  });
}; // the note without a new version, for the UI matrix (dev-tools/ui-routes/update-note*.js) and the review scenario
// update-note (src/dev/scenarios.js: dev and the test build); it stays until closed, for the screenshot


if (process.env.DEV || process.env.SCENARIOS) window.__showUpdateNote = function () {
  return showNote(function () {}, 0);
}; // the note while the app runs; register-service-worker.js calls it when a new version has been installed

export var offerNewVersion = function offerNewVersion(reg) {
  if (!ON || starting || taking || noted || !reg.waiting) return;
  noted = true; // gone (closed, its time up, a Reload that didn't take): a version found later is offered again

  showNote(function () {
    take(reg);
  }, NOTE_TIME, function () {
    noted = false;
  });
}; // a new version took over this page: asked for here, the reload into it; taken in another tab (which removed the files
// of this page's version), a hidden page reloads unseen and a page in sight keeps the note until Reload or the cross

var onNewController = function onNewController() {
  if (taking || document.visibilityState === 'hidden') window.location.reload();else showNote(function () {
    return window.location.reload();
  }, 0);
}; // a version still downloading: the note once it is in


var offerWhenInstalled = function offerWhenInstalled(reg) {
  if (reg.installing) installed(reg.installing).then(function (ok) {
    if (ok) offerNewVersion(reg);
  });
};

var watchReturns = function watchReturns(reg) {
  var checked = Date.now();
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || Date.now() - checked < RECHECK) return;
    checked = Date.now();
    reg.update().then(function () {
      return offerWhenInstalled(reg);
    }, function () {});
  });
}; // the password-reset page keeps its token in this page's memory when sessionStorage is refused (boot/reset-token.js):
// no reload there at the start


var keepPage = function keepPage() {
  return /\/reset-password\/?$/.test(window.location.pathname);
}; // at the start: a new version that is waiting, or that the check finds and downloads within the budget


var readyAtStart =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(reg) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!reg.waiting) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", true);

          case 2:
            _context.next = 4;
            return reg.update();

          case 4:
            if (!reg.installing) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", installed(reg.installing));

          case 6:
            return _context.abrupt("return", !!reg.waiting);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readyAtStart(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default
/*#__PURE__*/
_asyncToGenerator(
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee2() {
  var reg, ready;
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (ON) {
            _context2.next = 2;
            break;
          }

          return _context2.abrupt("return");

        case 2:
          if (window.caches) caches.open(MODE_CACHE).catch(function () {});
          reg = null;
          _context2.prev = 4;

          if (!navigator.serviceWorker.controller) {
            _context2.next = 11;
            break;
          }

          _context2.next = 8;
          return navigator.serviceWorker.getRegistration();

        case 8:
          _context2.t0 = _context2.sent;
          _context2.next = 12;
          break;

        case 11:
          _context2.t0 = null;

        case 12:
          reg = _context2.t0;
          if (reg) navigator.serviceWorker.addEventListener('controllerchange', onNewController);

          if (!(reg && !justReloaded() && !keepPage())) {
            _context2.next = 21;
            break;
          }

          _context2.next = 17;
          return Promise.race([readyAtStart(reg).catch(function () {
            return false;
          }), wait(BUDGET, false)]);

        case 17:
          ready = _context2.sent;

          if (!ready) {
            _context2.next = 21;
            break;
          }

          _context2.next = 21;
          return take(reg);

        case 21:
          _context2.next = 25;
          break;

        case 23:
          _context2.prev = 23;
          _context2.t1 = _context2["catch"](4);

        case 25:
          starting = false;

          if (reg) {
            _context2.next = 28;
            break;
          }

          return _context2.abrupt("return");

        case 28:
          offerNewVersion(reg);
          offerWhenInstalled(reg);
          watchReturns(reg);

        case 31:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[4, 23]]);
}));